import { NgModule, Type, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TokenProvider } from './token-provider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token-interceptor';
import { RefreshTokenProvider } from './refresh-token.provider';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';

@NgModule({
  imports: [CommonModule],
})
export class SharedTokenInterceptorModule {
  public static forRoot(config: {
    tokenProvider: Type<TokenProvider>;
    refreshTokenProvider: Type<RefreshTokenProvider>;
  }): ModuleWithProviders {
    return {
      ngModule: SharedTokenInterceptorModule,
      providers: [
        {
          multi: true,
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
        },
        {
          multi: true,
          provide: HTTP_INTERCEPTORS,
          useClass: RefreshTokenInterceptor,
        },
        {
          provide: TokenProvider,
          useClass: config.tokenProvider,
        },
        {
          provide: RefreshTokenProvider,
          useClass: config.refreshTokenProvider,
        },
      ],
    };
  }
}
